﻿export class productComparerProdArtDto
{
    productID;
    articleID;
    articleNumber;

    constructor(data)
    {
        if (data)
        {
            this.productID = data.productID;
            this.articleID = data.articleID;
            this.articleNumber = data.articleNumber;
        }
    }
};